<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap class="custom-mb">

            <v-flex sm12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                           
                            <h3>Edit Users </h3>
                        
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <router-link class="link-btn square-btn" :to="{name: 'Users'}">
                            <v-icon color="black" medium>fa-chevron-left</v-icon>
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-form v-model="valid">

                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    <v-flex lg6 md6 xs12>
                                        <v-text-field label="First Name *" :maxlength="32" v-model="form.first_name" v-validate="{required: 'form.first_name', max: 32, no_special_char: 'form.first_name'}" data-vv-name="first_name" placeholder="" :error-messages="errors.collect('first_name')" required data-vv-as="First Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg6 md6 xs12>
                                        <v-text-field label="Last Name *" :maxlength="32" v-model="form.last_name" v-validate="{required: 'form.last_name', max: 32, no_special_char: 'form.last_name'}" data-vv-name="last_name" placeholder="" :error-messages="errors.collect('last_name')" required data-vv-as="Second Name">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Address *" autocomplete="off" class="white-placeholder" v-model="form.address" v-validate="{required: true,address: [hidden_address]}" id="address" data-vv-name="address" data-vv-as="Address" placeholder="" required :error-messages="errors.collect('address')" @input="getAddressData('address')">
                                        </v-text-field>
                                    </v-flex>
                                    <input :type="'hidden'" v-model="hidden_address" ref="hidden_address" data-vv-name="hidden_address">

                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Secondary Address" :maxlength="64" v-validate="{max: 64}" v-model="form.address2" data-vv-name="address2" placeholder="" :error-messages="errors.collect('address2')" required data-vv-as="Secondary Address">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg6 md6 xs12>
                                        <v-text-field label="Personal/Cell Number *" :maxlength="11" v-model="form.phone_1" v-validate="{required:'form.phone_1', numeric: 'form.phone_1', custom_contact: 'form.phone_1'}" data-vv-name="phone_1" placeholder="" :error-messages="errors.collect('phone_1')" required data-vv-as="Contact" :mask="`${contactNumberMaskForInput}`">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg6 md6 xs12>
                                        <v-text-field label="Posting Contact Number" :maxlength="11" v-model="form.phone_2" v-validate="{ required:'form.phone_2', numeric: 'form.phone_2', custom_contact:'form.phone_2'}" data-vv-name="phone_2" placeholder="" :error-messages="errors.collect('phone_2')" required data-vv-as="Posting Contact" :mask="`${contactNumberMaskForInput}`">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-autocomplete :items="form.roles" v-validate="{required:true}" :error-messages="errors.collect('roles')" data-vv-name="roles" data-vv-rules="roles" v-model="selectedItems" required data-vv-as="Roles" item-text="name" item-value="role_id" label="Select Roles *" autocomplete multiple @change="onRoleChange">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex lg4 md4 xs12 v-if="isLoadMcNo">
                                        <v-text-field :label="isMcNoMandatoryFlag ? 'MC Number*' : 'MC Number'" :disabled="isDisableCmpnyInfo" v-model="form.mc_number" :maxlength="24" v-validate="{required : isMcNoMandatoryFlag == true ? true : false,'max': 24, no_special_char: 'form.mc_number'}" data-vv-name="mc_number" placeholder="" :error-messages="errors.collect('mc_number')" required data-vv-as="MC Number">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg4 md4 xs12 v-if="isLoadDotNo">
                                        <v-text-field label="DOT Number" :disabled="isDisableCmpnyInfo"  v-model="form.dot_number" :maxlength="24" v-validate="{'max': 24, no_special_char: 'form.dot_number'}" data-vv-name="dot_number" placeholder="" :error-messages="errors.collect('dot_number')" data-vv-as="DOT Number">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg4 md4 xs12 v-if="isLoadCompany">
                                        <v-text-field label="Company Name *" :disabled="isDisableCmpnyInfo" v-model="form.company_name" v-validate="{required: 'form.company_name'}" data-vv-name="company_name" placeholder="" :error-messages="errors.collect('company_name')" required data-vv-as="Company Name">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Company Address" :disabled="isDisableCmpnyInfo" autocomplete="off" class="white-placeholder" v-model="form.company_address" v-validate="{company_address: [hidden_company_address]}" id="company_address" data-vv-name="company_address" data-vv-as="Company Address" placeholder="" :error-messages="errors.collect('company_address')" @input="getAddressData('company_address')">
                                        </v-text-field>
                                    </v-flex>
                                    <input :type="'hidden'" v-model="hidden_company_address" ref="hidden_company_address" data-vv-name="hidden_company_address">

                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Company Address 2" :maxlength="64" v-model="form.company_alternate_address" data-vv-name="company_alternate_address" placeholder="" :error-messages="errors.collect('company_alternate_address')" required data-vv-as="Company Address 2">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex lg4 md4 xs12>
                                        <label
                                        aria-hidden="true"
                                        class="v-label theme--light"
                                        style="left: 0px; right: auto; position: relative;">
                                        TIA Status
                                        </label>
                                        <v-switch v-model="form.tia_status">
                                        </v-switch>
                                    </v-flex>
                                    <v-flex lg4 md4 xs12 v-if="form.status != 'postonce' && form.status != 'posteverywhere'">
                                        <v-select class="custom_dropdown" v-validate="'required'" :items="user_status_arr" :error-messages="errors.collect('status')" data-vv-name="status" v-model="form.status" required data-vv-as="User Status" item-text="name" item-value="value" label="User Status">
                                        </v-select>
                                    </v-flex>
                                    <v-flex lg4 md4 xs12 v-else>
                                        <label data-v-e1595a56="" aria-hidden="true" class="v-label theme--light" style="left: 0px; right: auto; position: relative;">
                                        Status
                                        </label>
                                        <v-text-field disabled v-model="form.status"></v-text-field>                                        
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <div class="form-btn text-xs-right">
                                <v-btn color="gray white--text" :to="{name:'Users'}"><v-icon color="white">fa-times-circle</v-icon>Cancel</v-btn>
                                <v-btn color="green white--text" @click="submit"> Save </v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>

        </v-layout>
    </v-container>
</div>
</template>

<script>
import services from "../../services/HttpService";
import axios from "axios";
import breadcrumbs from "../widgets/Breadcrumb";
import config from "../../config";
import GoogleAds from "@/pages/widgets/GoogleAds";
import {
    Validator
} from 'vee-validate';

const ADDRESS_COMPONENTS = {
    subpremise: 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};

const ADDRESS_COMPONENTS2 = {
    subpremise: 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};

Validator.extend('address', {
    getMessage: field => 'The ' + field + ' field is Invalid.',
    validate: function (value, [oth]) {
        if (oth == '') {
            return false;
        }
        return true;
    }
});

Validator.extend('company_address', {
    getMessage: field => 'The ' + field + ' field is Invalid.',
    validate: function (value, [oth]) {
        if (oth == '') {
            return false;
        }
        return true;
    }
});

export default {
    $_veeValidate: {
        validator: 'new'
    },
    data: () => ({
        isAdmin: false,
        canLeaveWithoutPrompt: false,
        contactNumberMaskForInput:config.contactNumberMaskForInput,
        valid: true,
        isAddrEmpty: true,
        isAddrDirty: false,
        form: {
            email: '',
            password: '',
            first_name: '',
            last_name: '',
            phone_1: '',
            phone_2: '',
            address: '',
            company_address: '',
            country: '',
            state: '',
            state_name: '',
            city: '',
            latitude: '',
            longitude: '',
            pincode: '',
            company_country: '',
            company_state: '',
            company_city: '',
            company_latitude: '',
            company_longitude: '',
            company_pincode: '',
            address2: '',
            company_alternate_address: '',
            roles: [],
            disable: false,
            admin_disable: false,
            tia_status: false,
            mc_number: '',
            dot_number: '',
            company_name: '',
            status: 'active',
            role_slug: '',
            since: '',
            website: '',
            equipment_type: '',
            hobbies: '',
        },
        hidden_address: '',
        hidden_company_address: '',
        isDisableCmpnyInfo: false,
        breadcrumbs: [{
                name: 'Dashboard',
                to: "/dashboard",
                disabled: false
            },
            {
                name: 'Reporting',
                to: "/comingsoon",
                disabled: false
            },
            {
                name: 'Users',
                to: "/users/list",
                disabled: false
            },
            {
                name: 'Edit User',
                disabled: true
            }
        ],
        selectedItems: [],
        user_status_arr: [],
        isLoad: false,
        isLoadMcNo: false,
        isLoadDotNo: false,
        isLoadCompany: false,
        isMcNoMandatoryFlag: false,
        ModulePermissions: {},
        rolesUsedByChild: [],

    }),
    beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        } else {
            if (this.canLeaveWithoutPrompt) {
                return next();
            }
            next(window.confirm('Do you really want to leave? You have unsaved changes!'));
        }
    },
    components: {
        breadcrumbs,
        GoogleAds
    },
    mounted() {
        
        const self = this;
        self.$validator.localize('en', self.dictionary);

        // google place api for origin address
        const options = {};
        
        self.origin_autocomplete = new google.maps.places.Autocomplete(
            document.getElementById('address'),
            options
        );

        self.origin_autocomplete2 = new google.maps.places.Autocomplete(
            document.getElementById('company_address'),
            options
        );
        
        self.origin_autocomplete.setComponentRestrictions({
            'country': ['CAN', 'US']
        });

        self.origin_autocomplete2.setComponentRestrictions({
            'country': ['CAN', 'US']
        });

        self.origin_autocomplete.addListener('place_changed', function () {
            let place = self.origin_autocomplete.getPlace();
            if (place.address_components !== undefined) {
                self.formatResult(place);
            } else {
                self.hidden_origin_address = '';
            }
        });
        
        self.origin_autocomplete2.addListener('place_changed', function () {
            let place2 = self.origin_autocomplete2.getPlace();
            if (place2.address_components !== undefined) {
                self.formatResultCompanyAddress(place2);
            } else {
                self.hidden_company_address = '';
            }
        });

        if(self.$store.state.user.Issuperadmin == true){
            self.user_status_arr.push({
                name: 'Active',
                value: 'active'
            }, 
           
            {
                name: 'Disabled',
                value: 'disabled'
            }, {
                name: 'Cancelled',
                value: 'cancelled'
            });
        }  
        else{
            self.user_status_arr.push({
                name: 'Active',
                value: 'active'
            },
            {
                name: 'Disabled',
                value: 'disabled'
            });
        }
    },
    created() {
        const self = this,
            wApp = window.getApp;
        this.isAdmin = self.$store.state.user.parentId ? false : true;
        wApp.$emit("showLoader", {
            show: true
        });
        axios.all([
                services.get("users/getUserRoles", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }),
                services.post("users/userListById", {
                    uuid: this.$route.params.id
                }, {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }),
                services.post("users/getChildRolesByUuid", {
                    uuid: this.$route.params.id
                }, {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                }),
            ])
            .then(axios.spread(function (roles, users, rolesUsedByChild) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self.rolesUsedByChild = rolesUsedByChild.data.data.roleid.split(',');
                self.form = users.data.data.User.UserContacts;
                self.form.email = users.data.data.User.email;
                self.form.password = users.data.data.User.password;
                if(users.data.data.User.status == 'pending'){
                    self.user_status_arr.push({
                        name: 'Pending',
                        value: 'pending'
                    });
                }
                self.form.status = users.data.data.User.status;
                self.form.dot_number = users.data.data.User.dot_number;
                self.form.mc_number = users.data.data.User.mc_number;
                self.form.company_name = users.data.data.User.company_name;
                self.form.company_address = users.data.data.User.company_address;
                self.form.company_city = users.data.data.User.company_city;
                self.form.company_country = users.data.data.User.company_country;
                self.form.company_latitude = users.data.data.User.company_latitude;
                self.form.company_longitude = users.data.data.User.company_longitude;
                self.form.company_state = users.data.data.User.company_state;
                self.form.company_alternate_address = users.data.data.User.company_alternate_address;
                self.form.since = users.data.data.User.since;
                self.form.website = users.data.data.User.website;
                self.form.equipment_type = users.data.data.User.equipment_type;
                self.form.hobbies = users.data.data.User.hobbies;
                self.form.company_desc = users.data.data.User.company_desc;
                //self.form.roles = roles.data.data;
                self.hidden_address = self.form.address;
                self.hidden_company_address = self.form.company_address;
                
                const result = users.data.data.User.UserRoles.map(a => a.role_id);
                console.log(result);
                self.selectedItems = result;

                let roleObj = [];
                roles.data.data.map(function (data) {
                    if(data){
                        const reObj = {};
                        reObj.role_id = data.role_id;
                        reObj.name = [];
                        data.ModulePermissions.map(function (data1) {
                            reObj.name.push(data1.Module.slug);
                            reObj.p_name = data1.p_name;
                        });
                        self.ModulePermissions[data.role_id] = reObj;
                        if(self.rolesUsedByChild.includes(data.role_id.toString())){
                            data.disabled = true;
                        }
                        roleObj.push(data);
                    }
                });
                self.form.roles = roleObj;
                self.onRoleChange();
                
                // result.map(function (data) {
                //     if ((typeof self.ModulePermissions[data] != 'undefined') && ((self.ModulePermissions[data].name.includes('loads') && self.ModulePermissions[data].p_name == 'all') || (self.ModulePermissions[data].name.includes('trucks') && self.ModulePermissions[data].p_name == 'all'))) {
                //         self.isLoad = true;
                //         self.isLoadMcNo = true;
                //         self.isLoadCompany = true;
                //         if(self.$store.state.user.Issuperadmin != true){
                //             if(self.form.mc_number != '' && self.form.company_name != ''){
                //                 self.isDisableCmpnyInfo = true;
                //                 self.isLoadDotNo = true;
                //             }
                //         }
                        
                //         if(self.ModulePermissions[data].name.includes('trucks') && self.ModulePermissions[data].p_name == 'all'){
                //             self.isLoadDotNo = true;    
                //         }
                //     }
                // });
            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, "red");
            });
    },

    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        /**
         * Format result from Geo google APIs
         * @param place
         * @returns {{formatted output}}
         */
        formatResult: function (place) {
            const self = this;
            let returnData = {};
            for (let i = 0; i < place.address_components.length; i++) {
                let addressType = place.address_components[i].types[0];

                if (ADDRESS_COMPONENTS[addressType]) {
                    let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                    returnData[addressType] = val;
                }

                if(addressType == 'administrative_area_level_1'){
                    let val2 = place.address_components[i]['long_name'];
                    returnData['state_name'] = val2;
                }
            }
            returnData['latitude'] = place.geometry.location.lat();

            self.form['address'] = '';
            self.form['address'] = place.formatted_address;
            self['hidden_address'] = place.formatted_address;
            self.form['city'] = returnData.locality;
            self.form['state'] = returnData.administrative_area_level_1;
            self.form['state_name'] = returnData.state_name;
            self.form['country'] = returnData.country;
            self.form['pincode'] = returnData.postal_code;
            self.form['latitude'] = place.geometry.location.lat();
            self.form['longitude'] = place.geometry.location.lng();
        },
        formatResultCompanyAddress: function (place) {
            const self = this;
            let returnData = {};
            for (let i = 0; i < place.address_components.length; i++) {
                let addressType = place.address_components[i].types[0];

                if (ADDRESS_COMPONENTS2[addressType]) {
                    let val = place.address_components[i][ADDRESS_COMPONENTS2[addressType]];
                    returnData[addressType] = val;
                }
            }
            returnData['latitude'] = place.geometry.location.lat();

            self.form['company_address'] = '';
            self.form['company_address'] = place.formatted_address;
            self['hidden_company_address'] = place.formatted_address;
            self.form['company_city'] = returnData.locality;
            self.form['company_state'] = returnData.administrative_area_level_1;
            self.form['company_country'] = returnData.country;
            self.form['company_pincode'] = returnData.postal_code;
            self.form['company_latitude'] = place.geometry.location.lat();
            self.form['company_longitude'] = place.geometry.location.lng();
        },
        getAddressData(data) {
            const self = this;
            self['hidden_' + data] = '';
            this.$validator.validate(data);
        },
        getAddressBlur: function (addressData, placeResultData, id) {
            this.isAddrDirty = true;
            this.isAddrEmpty = addressData.newVal.length <= 0;
        },
        submit() {
            const self = this,
                wApp = window.getApp;
            self.$validator.validateAll()
                .then(isValid => {
                    // Data is valid, so we can login now
                    if (isValid) {
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        const formData = Object.assign({},self.form);
                        delete formData.roles;
                        formData.roles = self.selectedItems.toString();
                        formData.uuid = formData.UserUuid;
                        delete formData.UserUuid;
                        
                        formData.role_slug = self.isLoadDotNo == true ? 'trucker' : 'other';
                        
                        services.put("users/edit", formData, {
                                "Authorization": "Bearer " + this.$store.state.user.token
                            })
                            .then(res => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                if (res.data.status) {
                                    self._showToast(res.data.message);
                                    self.canLeaveWithoutPrompt = true;
                                    self.$router.push("/users/list");
                                } else {
                                    self._showToast(res.data.message, "red");
                                } 
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, "red");
                            });
                    }
                })
        },
        clear() {
            this.form = {};
            this.$validator.reset();
        },
        onRoleChange(event) { 
            const self = this;
            self.isLoad = false;
            let isLoadMcNoFlag, isLoadDotNoFlag, isLoadCompanyFlag = false;
            self.isLoadMcNo = false;
            self.isLoadDotNo = false;
            self.isLoadCompany = false;
            self.isMcNoMandatoryFlag = false;

            if(self.selectedItems.length > 0){
                self.selectedItems.map(function (data) {
                    if ((self.ModulePermissions[data].name.includes('loads') && self.ModulePermissions[data].p_name == 'all') || (self.ModulePermissions[data].name.includes('trucks') && self.ModulePermissions[data].p_name == 'all')) {
                        if(!isLoadMcNoFlag && !isLoadCompanyFlag){
                            self.isLoadMcNo = true;
                            self.isLoadCompany = true;
                            isLoadMcNoFlag = true;
                            isLoadCompanyFlag = true;
                        }
                        if(self.ModulePermissions[data].name.includes('trucks') && self.ModulePermissions[data].p_name == 'all'){
                            if(!isLoadDotNoFlag){
                                self.isLoadDotNo = true;    
                                self.isMcNoMandatoryFlag = true;    
                                isLoadDotNoFlag = true;
                            }
                        }
                        
                        if(self.$store.state.user.parentId != '' && self.form.mc_number != '' && self.form.dot_number != '' && self.form.company_name != ''){
                            self.isDisableCmpnyInfo = true;
                            self.form.mc_number = self.$store.state.user.mc_number;
                            self.form.dot_number = self.$store.state.user.dot_number;
                            self.form.company_name = self.$store.state.user.company_name;
                        }
                    }
                });
            }
            else {
                    self.isLoadMcNo = false;
                    self.isLoadCompany = false;
                    self.isLoadDotNo = false;
                
            }
                        
        }
    }
};
</script>

<style lang="stylus" scoped>
.payment-method {
    border: 1px solid #eee
}

</style>



// WEBPACK FOOTER //
// src/pages/users/Edit.vue